import React, { useState } from 'react';
import Modal from './common/Modal';

interface CardCuttingModalProps {
  isOpen: boolean;
  onCut: (cutIndex: number) => void;
  onCancel: () => void;
}

const CardCuttingModal: React.FC<CardCuttingModalProps> = ({ isOpen, onCut, onCancel }) => {
  const [selectedCut, setSelectedCut] = useState<number>(16); // Default to middle

  if (!isOpen) return null;

  const handleCut = () => {
    onCut(selectedCut);
  };

  const footer = (
    <>
      <button className="ui-btn ui-btn-secondary" onClick={onCancel}>
        Cancel
      </button>
      <button className="ui-btn ui-btn-primary" onClick={handleCut}>
        Cut Deck
      </button>
    </>
  );

  return (
    <Modal title="Cut the Deck" onClose={onCancel} maxWidth={500} footer={footer}>
      <p style={{ marginBottom: '20px', color: 'var(--text-muted)' }}>
        The person to the right of the dealer will cut the deck. Select a position
        from 1 to 32 where the deck will be cut.
      </p>

      <div style={{ marginBottom: '8px' }}>
        <label className="ui-label">Cut Position: {selectedCut}</label>
        <input
          type="range"
          min="1"
          max="32"
          value={selectedCut}
          onChange={(e) => setSelectedCut(parseInt(e.target.value))}
          style={{
            width: '100%',
            height: '8px',
            borderRadius: '5px',
            accentColor: 'var(--accent)',
            outline: 'none',
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '5px',
            fontSize: '12px',
            color: 'var(--text-muted)',
          }}
        >
          <span>1</span>
          <span>16</span>
          <span>32</span>
        </div>
      </div>
    </Modal>
  );
};

export default CardCuttingModal;
